import styled from "styled-components"


export const TabDivver = styled.div`
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media ( max-width: 767px ) {
        padding: 16px;
    }
`

export const H1 = styled.h1`
    font-size: 20px;
`

export const H2 = styled.h2`
    font-size: 16px;
`